'use strict'

import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects'

import {
  FETCH_DATA,
  currenciesFetched,
  ratesFetched,
  ipInfoFetched,
  loading
} from './actions'

import { fetchCurrencies, fetchRates, fetchIpInfo } from './api'

function* requestData() {
  const state = yield select()
  const { isLoading } = state.rootReducer.utilsReducer
  if (!isLoading) yield put(loading(true))
  let result = yield call(fetchCurrencies)
  yield put(currenciesFetched(result.currencies, result.error))
  result = yield call(fetchRates)
  yield put(ratesFetched(result.rates, result.error))
  result = yield call(fetchIpInfo)
  yield put(ipInfoFetched(result.ipInfo, result.error))
  yield put(loading(false))
}

export function* watchFetchData() {
  yield takeLatest(FETCH_DATA, requestData)
}

export default function* rootSaga() {
  yield all([fork(watchFetchData)])
}
